const surveyMetaDefaultState = {
  title: '',
  callbackUrl: '',
  counts: {},
  backConfig: {}
}

const reducer = (state = surveyMetaDefaultState, action) => {
  switch (action.type) {
    case 'UPDATE_SURVEY_META':
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export { reducer }



// WEBPACK FOOTER //
// ./src/reducers/surveyMeta.js